import { IAgent } from "models/agents"
import { Warning } from "models/warnings"
import { IWorkspace } from "models/workspaces"
import { VariableCategory, VariableItem } from "pages/settings/workflows/workflow.defs"
import { CategoryEnum, VariableEnum } from "pages/settings/workflows/workflow.enums"
import { View } from "react-big-calendar"
import { atom } from "jotai"
import { atomWithStorage } from "jotai/utils"
import { CmdkCommand } from "components/navigation/Cmdk/CmdkItem"
import { GameState } from "pages/agents/components/RpgChat/rpg.types"

// Fix temporario
// ==========================================================================================
var skin = localStorage.getItem("skin") || (getHost()?.subdomain == "mola" || getHost()?.subdomain == "mola2" ? "mola" : "kinbox")

function getHost() {
  const partsLenght = import.meta.env?.PROD && import.meta.env.VITE_ENV !== "staging" ? 3 : 2
  let parts = window.location.host.split(".")
  let subdomain = ""
  if (parts.length >= partsLenght) {
    subdomain = parts[0]
  }
  return { subdomain }
}

const isMolaSkin = () => {
  return skin == "mola"
}
const isPortSkin = () => {
  return skin == "port" || getHost()?.subdomain === "port" || getHost()?.subdomain === "port2"
}

const getDefaultThemeBySkin = () => {
  if (isMolaSkin()) {
    return "purple"
  }
  if (isPortSkin()) {
    return "port"
  }
  return "light"
}
//========================================================================================================================

export const modalState = atom<React.ReactNode>(undefined)
export const callModalAtom = atom<React.ReactNode>(undefined)

export const modalLevel2Atom = atom<React.ReactNode>(undefined)

export type Theme = "dark" | "light" | "noir" | "blue" | "purple" | "port" | "stone"

export const themeAtom = atomWithStorage<Theme>("theme", getDefaultThemeBySkin(), undefined, {
  getOnInit: true,
})

export const adminWorkspacesAtom = atomWithStorage<Partial<IWorkspace>[]>("admin-workspaces", [])

export const appLoaderAtom = atom<boolean>(false)

export const openCalendarAtom = atom<boolean>(false)

export const openNewsAtom = atom<boolean>(false)

export const openGlobalSearchAtom = atom<boolean>(false)

export const lastDashboardSnapshotIdAtom = atom<string | null>(null)

export const themeIconsAtom = atomWithStorage<"rounded" | "flat">("themeIconsLocal", "flat")

export type IDiceAvatar =
  | "open-peeps"
  | "initials"
  | "adventurer"
  | "adventurer-neutral"
  | "avataaars"
  | "big-ears"
  | "big-ears-neutral"
  | "big-smile"
  | "bottts"
  | "croodles"
  | "croodles-neutral"
  | "micah"
  | "miniavs"
  | "personas"
  | "pixel-art"
  | "pixel-art-neutral"
  | "thumbs"
  | "notionists"
  | "lorelei"
  | "avataaars-neutral"

interface IDiceAvatarWithLabel {
  label: string
  type: IDiceAvatar
}

export const diceAvatars: IDiceAvatarWithLabel[] = [
  { type: "initials", label: "Iniciais" },
  { type: "open-peeps", label: "Peep" },
  { type: "avataaars", label: "Avataaars" },
  { type: "micah", label: "Micah" },
  { type: "miniavs", label: "Miniavs" },
  { type: "personas", label: "Personas" },
  { type: "avataaars-neutral", label: "Nariz grande" },
  { type: "lorelei", label: "Lorelei" },
  { type: "notionists", label: "Notionists" },
  { type: "thumbs", label: "Thumbs" },
]

export const themeAvatarAtom = atomWithStorage<IDiceAvatar>("themeAvatarLocal", "initials")

export const sideOpenAtom = atomWithStorage<boolean>(
  "side-open",
  getHost()?.subdomain === "mobile" || window.innerWidth <= 768 || import.meta.env.VITE_ALDEIA === "true" ? false : true,
  undefined,
  {
    getOnInit: true,
  },
)

export const randomKeyAtom = atom<string | null>(null)

export const isMobileAtom = atom<boolean>(false)

export const reconnectedCountAtom = atom<number>(0)

export const awaitingTranscribeAtom = atom<{ conversationId: string; transcribed: boolean; refetchedMessages: boolean } | null>(null)

export const imageViewerAtom = atom<{ src: string; alt: string; downloadUrl: string } | null>(null)

interface UserInfoNotifications {
  enable_desktop?: boolean
  new_message_assigned_to_me?: boolean
  new_room_message_mentioned?: boolean
  conversation_assigned_to_me?: boolean
}

export const userInfoAtom = atom<
  { newsUnreads: number; userId: number; notificationsUnreads: number; pushNotifications: UserInfoNotifications } | undefined
>(undefined)

export const masterLoadedAtom = atom<boolean>(false)

export interface WorkspaceSessions {
  sessions: {
    [token: string]: {
      sessionCreatedAt: string
      device: string
      ip: string
      isMobile: boolean
      sessionId: string
    }
  }
}

export const sessionsLimitReachedAtom = atom<WorkspaceSessions | undefined>(undefined)

export const calendarPeriodViewAtom = atomWithStorage<View>("calendar-period-view", "day")

export const warningsAtom = atom<null | Warning>(null)

export const warningsHiddenAtom = atomWithStorage<Record<string, boolean>>("hidden-warnings", {})

export const adminAtom = atom<{ masterPassword?: string; isSystemAdmin?: boolean; loading?: boolean }>({
  loading: true,
})

export const assistantStreamTextAtom = atom<string>("")

export const slaveWorkspaceCountsAtom = atom<Record<string, number>>({})

export const variableAtom = atom<{
  variablesRecord: Record<VariableEnum, VariableItem>
  categoryWithVariablesRecord: Record<CategoryEnum, VariableCategory & { variables: VariableItem[] }>
}>({
  variablesRecord: {} as any,
  categoryWithVariablesRecord: {} as any,
})

export const sidebarCollapsedAtom = atom<boolean>(false)

export const modalConfirmAtom = atom<any>(null)

export const modalPickerAtom = atom<{
  title: string
  commands: CmdkCommand[]
} | null>(null)

export const toastAtom = atom<any>(null)
export const isAldeiaAtom = atomWithStorage("isAldeiaLocal", import.meta.env.VITE_ALDEIA === "true")

export const rpgAtom = atom<GameState | null>(null)
